export default __webpack_public_path__ + "static/media/vendor.ff859dd1.svg";